import { ComponentData } from './../../models/dynamic-component/component-data.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'ngxui-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnInit {
    @Input() TabId: number;
    @Input() Title: string;
    @Input() Active: boolean;
    @Input() Closable: boolean = true;
    @Input() FaviconClass: string;
    @Input() Loading: boolean = false;
    @Input() Deleted: boolean = false;
    @Input() MyComponentData: ComponentData;
    /*Settings*/
    @Input() tabPosition: any;
    @Input() contentWidth: number;
    @Input() tabWidth: number;

    @Output() closeEvent: EventEmitter<TabComponent> = new EventEmitter<TabComponent>();

    constructor() { }

    ngOnInit() {
    }

}
